import {
  preShiftOrientationContract,
  type PreShiftOrientationsResponse,
} from "@clipboard-health/contract-backend-main";
import { useGetParsedQuery, type UseGetParsedQueryOptions } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { type UseQueryResult } from "@tanstack/react-query";

const { getPreShiftOrientationsByWorker } = preShiftOrientationContract;
const { 200: responseSchema } = getPreShiftOrientationsByWorker.responses;

export function getPreShiftOrientationsUrl(workerId: string): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/pre-shift-orientations`;
}

export function useGetPreShiftOrientations(
  options: UseGetParsedQueryOptions<typeof responseSchema> = {}
): UseQueryResult<PreShiftOrientationsResponse> {
  const { userId: workerId } = useDefinedWorker();

  return useGetParsedQuery({
    url: getPreShiftOrientationsUrl(workerId),
    responseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_PRE_SHIFT_ORIENTATIONS_FAILURE,
    },
    ...options,
  });
}
